module.exports = __webpack_public_path__ + "static/2-your-browser-encryption-669b4ef361b8384599b65b2b6605e486.jpg";